import React, { useState } from "react";
import { Tooltip, IconButton, Popover} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DeleteIcon from '@material-ui/icons/Delete';
import { useOfflineAssets } from "../../offline/useOfflineAssets";
import { DeleteAssetDialog } from "./DeleteAssetDialog";
import { LibraryItem } from "../../../entities/LibraryItem";
import { LibraryAssetActions } from "./LibraryAssetActions";

interface Props {
    focusedItem: LibraryItem | undefined;
}

export function RightSideInteractions(props: Props){
    const { onlineMode } = useOfflineAssets();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    if(!props.focusedItem)
        return null;

    if(!onlineMode)
        return null;

    return (
        <>
            <Tooltip title="Remove">
            <IconButton aria-label="Remove" onClick={() => setShowDeleteDialog(true)}>
                <DeleteIcon style={{opacity: .54, fontSize: 13, height: 20, width: 20, color: "rgb(32, 33, 36)"}} />
            </IconButton>
            </Tooltip>
            <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} >
                <MoreVertIcon style={{opacity: .54, fontSize: 13, height: 20, width: 20, color: "rgb(32, 33, 36)"}} />
            </IconButton>
            <DeleteAssetDialog focusedItem={props.focusedItem} open={showDeleteDialog} onClose={() => setShowDeleteDialog(false)} />
            <Popover 
                open={anchorEl !== null} 
                onClose={() => setAnchorEl(null)}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                anchorEl={anchorEl}
            >
                <LibraryAssetActions focusedItem={props.focusedItem} onClose={() => setAnchorEl(null)} />
            </Popover>
        </>
    )
}